"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTrailingSlash = function (str) {
    return str.replace(/\/$/, '');
};
exports.isNull = function (val) {
    var v = val !== null && val !== undefined ? val.toString() : null;
    return v === null || v.length === 0;
};
exports.capitalizeFirstLetters = function (str) {
    var words = str.split(' ');
    var capWords = words.map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); });
    return capWords.join(' ');
};
//https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
exports.getParameterByName = function (name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[[]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
exports.getRandomString = function () {
    var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    return randLetter + Date.now();
};
/** remove hash, query, trailing slash from path */
exports.cleanPath = function (path) {
    var delimiter = /\/#|#|\?|\/$/g; // /# or # or ? or trailing /
    return path.split(delimiter)[0];
};
